import React from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { me } from '../initial_state'
import { CX, SEARCH_TAB_MARKETPLACE, SEARCH_TABS } from '../constants'
import { changeSearch, submitSearch, toggleFocused } from '../actions/search'
import Button from './button'
import { parseQuerystring } from '../utils/querystring'
import { changeMarketplaceListingSearchQuery, fetchMarketplaceListingsBySearch, marketplaceSearchReset } from '../actions/marketplace_listing_search'

class Search extends React.Component {
  get searchTab() {
    const { pathname } = this.props.location
    const found = SEARCH_TABS.find(item => item.to === pathname)
    return found || SEARCH_TABS[0]
  }

  get q() {
    const { q } = parseQuerystring({ q: '' })
    return q    
  }

  componentDidMount() {
    if (this.props.location.pathname.startsWith('/search')) {
      const { textbox } = this
      if (textbox) {
        // this wont always focus with dev tools open
        textbox.focus()
        const vlen = this.q.length
        if (vlen > 0) {
          textbox.selectionStart = vlen
          textbox.selectionEnd = vlen
        }
      }
    }
  }

  handleOnChange = (evt) => {
    const { isXS, onChange } = this.props
    const value = evt?.target?.value
    onChange(value)

    if (isXS) this.debouncedSubmit()
  }

  debouncedSubmit = debounce(() => {
    const { isXS, onSubmit, marketSearch, value } = this.props
    const { tab } = this.searchTab
    if (!isXS) return

    if (tab === SEARCH_TAB_MARKETPLACE) {
      marketSearch(value)
    } else {
      onSubmit()
    }
  }, 650, { leading: true })

  handleOnFocus = () => this.props.onToggleFocused(true)

  // Blur is deferred because "Cancel" disappears if this goes first.
  handleOnBlur = () => setTimeout(() => this.props.onToggleFocused(false), 30)

  setTextbox = ref => (this.textbox = ref)

  formSubmit = (e) => {
    const { history, value, to } = this.props
    history.push(`${to || this.searchTab.to}?q=${encodeURIComponent(value)}`)
    e.preventDefault()
    return false
  }

  render() {
    const {
      value = '',
      focused,
      isInNav,
      theme,
      className,
      placeholder,
      to,
    } = this.props
    const highlighted = focused || value.length > 0

    const inputClasses = CX({
      d: 1,
      text: 1,
      outlineNone: 1,
      lineHeight125: 1,
      displayBlock: 1,
      py7: 1,
      bgTransparent: 1,
      cPrimary: 1,
      fs15PX: 1,
      flexGrow1: 1,
      radiusSmall: 1,
      textIndent15PX: 1,
      searchInput: 1,
      darkPlaceholderOnLight: !!to,
    })

    const isLight = ['light', 'white'].indexOf(theme) > -1

    const containerClasses = CX(className, {
      d: 1,
      searchNavigation: (!highlighted && isInNav && isLight) || (isInNav && theme !== 'light'),
      bgWhite: (highlighted && isInNav && theme === 'light' && !className),
      bgPrimary: !isInNav && !className,
      flexRow: 1,
      pr5: 1,
      radiusSmall: !isInNav && !className,
      circle: isInNav && !className,
      border1PX: !!to,
      borderColorSecondary: !!to,
      aiCenter: 1,
    })

    const prependIconColor = (highlighted || !isInNav || theme === 'white') ? 'brand' : 'white'
    const thePlaceholder = placeholder || 'Search Gab'
    const id = 'nav-search'

    return (
      <div className={[_s.d, _s.jcCenter, _s.h53PX].join(' ')}>
        <form className={containerClasses} method="GET" onSubmit={this.formSubmit}>
          <label className={_s.visiblyHidden} htmlFor={id}>Search</label>
          <input
            id={id}
            name="q"
            className={inputClasses}
            type='text'
            placeholder={thePlaceholder}
            ref={this.setTextbox}
            value={value}
            onChange={this.handleOnChange}
            onFocus={this.handleOnFocus}
            onBlur={this.handleOnBlur}
            autoComplete='off'
          />
          <Button
            className={[_s.px10].join(' ')}
            tabIndex='0'
            title='Submit search'
            backgroundColor='none'
            color={prependIconColor}
            icon='search'
            iconClassName={_s.fillInherit}
            iconSize='16px'
          />
        </form>
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  value: state.getIn(['search', 'value']),
  focused: state.getIn(['search', 'focused']),
  isLoading: state.getIn(['search', 'isLoading']),
  theme: state.getIn(['settings', 'displayOptions', 'theme']),
})

const mapDispatchToProps = (dispatch) => ({
  onChange: (value) => dispatch(changeSearch(value)),
  onSubmit: (type) => dispatch(submitSearch(type)),
  onToggleFocused: (focused) => dispatch(toggleFocused(focused)),
  marketSearch: (value) => {
    // reset so we don't conflict with if a user visits /marketplace
    dispatch(marketplaceSearchReset())
    dispatch(changeMarketplaceListingSearchQuery(value))
    dispatch(fetchMarketplaceListingsBySearch())
    dispatch(marketplaceSearchReset())
  }
})

Search.propTypes = {
  isInNav: PropTypes.bool,
  placeholder: PropTypes.string,
  isXS: PropTypes.bool,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search))
